const STORAGE_KEY = 'odus_tenant_portal_session';

export function getTenantPortalSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.tenantId || !data?.email) return null;
    return data;
  } catch {
    return null;
  }
}

export function setTenantPortalSession({ tenantId, email, fullName }) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      tenantId,
      email,
      fullName: fullName || '',
    })
  );
  window.dispatchEvent(new Event('odus-tenant-portal-session'));
}

export function clearTenantPortalSession() {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event('odus-tenant-portal-session'));
}
